import { create } from "zustand";

interface FilterState {
  filters: string[];
  setFilters: (filters: string[]) => void;
}

const useFilterStore = create<FilterState>((set) => ({
  filters: ["NONE"],
  setFilters: (filters) => set({ filters }),
}));

export { useFilterStore };
